// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 1.3.0 (commit ).

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import {
  AlgebraicType,
  AlgebraicValue,
  BinaryReader,
  BinaryWriter,
  ConnectionId,
  DbConnectionBuilder,
  DbConnectionImpl,
  Identity,
  ProductType,
  ProductTypeElement,
  SubscriptionBuilderImpl,
  SumType,
  SumTypeVariant,
  TableCache,
  TimeDuration,
  Timestamp,
  deepEqual,
  type CallReducerFlags,
  type DbContext,
  type ErrorContextInterface,
  type Event,
  type EventContextInterface,
  type ReducerEventContextInterface,
  type SubscriptionEventContextInterface,
} from "@clockworklabs/spacetimedb-sdk";
import { Point as __Point } from "./point_type";

export type SetChar = {
  name: string,
  sprite: string,
  size: number,
  friendly: boolean,
  position: __Point,
  initMod: number | undefined,
};

/**
 * A namespace for generated helper functions.
 */
export namespace SetChar {
  /**
  * A function which returns this type represented as an AlgebraicType.
  * This function is derived from the AlgebraicType used to generate this type.
  */
  export function getTypeScriptAlgebraicType(): AlgebraicType {
    return AlgebraicType.createProductType([
      new ProductTypeElement("name", AlgebraicType.createStringType()),
      new ProductTypeElement("sprite", AlgebraicType.createStringType()),
      new ProductTypeElement("size", AlgebraicType.createU32Type()),
      new ProductTypeElement("friendly", AlgebraicType.createBoolType()),
      new ProductTypeElement("position", __Point.getTypeScriptAlgebraicType()),
      new ProductTypeElement("initMod", AlgebraicType.createOptionType(AlgebraicType.createI32Type())),
    ]);
  }

  export function serialize(writer: BinaryWriter, value: SetChar): void {
    SetChar.getTypeScriptAlgebraicType().serialize(writer, value);
  }

  export function deserialize(reader: BinaryReader): SetChar {
    return SetChar.getTypeScriptAlgebraicType().deserialize(reader);
  }

}


